/**
 * 发票类型常量定义
 */
export const INVOICE_TYPE = {
  SPECIAL: '0', // 增值税专用发票
  NORMAL: '1', // 增值税普通发票
  ELECTRONIC: '2', // 增值税电子发票
  ELECTRONIC_SPECIAL: '3', // 增值税电子专用发票
  ELECTRONIC_SPECIAL_INVOICE: '31', // 电子发票（增值税专用发票）
  ELECTRONIC_NORMAL: '32', // 电子发票（增值税普通发票）
  BLOCKCHAIN: '41', // 区块链电子发票
  MACHINE_PRINTED: '42', // 机打发票
  OTHER_REIMBURSABLE: '43', // 可报销其他发票
}

/**
 * 发票类型枚举
 */
export const invoiceTypeList = [
  // 增值税专用发票 可以不传附件
  {
    label: '增值税专用发票',
    value: INVOICE_TYPE.SPECIAL,
  },
  // 增值税普通发票 可以不传附件
  {
    label: '增值税普通发票',
    value: INVOICE_TYPE.NORMAL,
  },
  {
    label: '增值税电子发票',
    value: INVOICE_TYPE.ELECTRONIC,
  },
  {
    label: '增值税电子专用发票',
    value: INVOICE_TYPE.ELECTRONIC_SPECIAL,
  },
  {
    label: '电子发票（增值税专用发票）',
    value: INVOICE_TYPE.ELECTRONIC_SPECIAL_INVOICE,
  },
  {
    label: '电子发票（增值税普通发票）',
    value: INVOICE_TYPE.ELECTRONIC_NORMAL,
  },
  {
    label: '区块链电子发票',
    value: INVOICE_TYPE.BLOCKCHAIN,
  },
  {
    label: '机打发票',
    value: INVOICE_TYPE.MACHINE_PRINTED,
  },
  {
    label: '可报销其他发票',
    value: INVOICE_TYPE.OTHER_REIMBURSABLE,
  },
]

/** 验证码后6位禁用：1-增值税普通发票 2-增值税电子发票 */
export const verifyCodeRequiredTypes = [INVOICE_TYPE.NORMAL, INVOICE_TYPE.ELECTRONIC]
/** 发票代码必填：0-增值税专用发票 1-增值税普通发票 2-增值税电子发票 3-增值税电子专用发票 41-区块链电子发票 42-机打发票 */
export const invoiceCodeRequiredTypes = [
  INVOICE_TYPE.SPECIAL,
  INVOICE_TYPE.NORMAL,
  INVOICE_TYPE.ELECTRONIC,
  INVOICE_TYPE.ELECTRONIC_SPECIAL,
  INVOICE_TYPE.BLOCKCHAIN,
  INVOICE_TYPE.MACHINE_PRINTED,
]
/** 附件必填-上传发票操作自动带出：2-增值税电子发票 3-增值税电子专用发票 31-电子发票（增值税专用发票） 32-电子发票（增值税普通发票） */
export const fileRequiredTypes = [
  INVOICE_TYPE.ELECTRONIC,
  INVOICE_TYPE.ELECTRONIC_SPECIAL,
  INVOICE_TYPE.ELECTRONIC_SPECIAL_INVOICE,
  INVOICE_TYPE.ELECTRONIC_NORMAL,
]
/** 附件必填-手动上传：41-区块链电子发票 42-机打发票 43-可报销其他发票 */
export const customFileRequiredTypes = [
  INVOICE_TYPE.BLOCKCHAIN,
  INVOICE_TYPE.MACHINE_PRINTED,
  INVOICE_TYPE.OTHER_REIMBURSABLE,
]
/** 可录入价税合计：43-可报销其他发票 */
export const amountEditabledTypes = [INVOICE_TYPE.OTHER_REIMBURSABLE]

/**
 * 录入发票表的列配置
 */
export const columns = [
  {
    label: '序号',
    type: 'index',
    width: 60,
  },
  {
    prop: 'invoiceType',
    label: '发票类型',
    width: 140,
    required: true,
    type: 'select',
    options: invoiceTypeList,
    rules: [{ required: true, message: '请选择发票类型' }],
    onchange: row => {
      // 需要清空的字段列表
      const propsToReset = [
        'invoiceCode',
        'verifyCode',
        'invoiceNo',
        'unTaxAmount',
        'taxRate',
        'taxAmount',
        'amount',
        'fileName',
        'fileUrl',
      ]

      if (customFileRequiredTypes.includes(row.invoiceType)) {
        propsToReset.forEach(prop => {
          if (prop === 'fileName') {
            row.fileName = ''
            row.fileUrl = ''
          } else {
            row[prop] = ''
          }
        })
      } else {
        ;['invoiceCode', 'verifyCode', 'fileName'].forEach(prop => {
          if (shouldResetProp(row, prop)) {
            row[prop] = ''
            if (prop === 'fileName') {
              row.fileName = ''
              row.fileUrl = ''
            }
          }
        })
      }
    },
  },
  {
    prop: 'invoiceDate',
    label: '开票日期',
    width: 140,
    required: true,
    type: 'date',
    rules: [{ required: true, message: '请选择开票日期' }],
  },
  {
    prop: 'invoiceNo',
    label: '发票号码',
    required: true,
    type: 'input',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            callback()
          } else if (!value) {
            callback(new Error('发票代码必填'))
          } else if (value.length > 30) {
            callback(new Error('发票号码长度最大30个字符'))
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'invoiceCode',
    label: '发票代码',
    required: true,
    type: 'input',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            callback()
          } else if (invoiceCodeRequiredTypes.includes(rule.row.invoiceType)) {
            if (!value) {
              callback(new Error('发票代码必填'))
            } else if (value.length > 30) {
              callback(new Error('发票代码长度最大30个字符'))
            }
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'verifyCode',
    label: '校验码后6位',
    required: true,
    type: 'input',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            callback()
          } else if (verifyCodeRequiredTypes.includes(rule.row.invoiceType)) {
            if (!value) {
              callback(new Error('校验码后6位必填'))
            } else if (value.length !== 6) {
              callback(new Error('校验码后6位长度应为6个字符'))
            }
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'unTaxAmount',
    label: '未税金额(元)',
    width: 140,
    required: true,
    type: 'input',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            callback()
          } else if (!value) {
            callback(new Error('未税金额必填'))
          } else if (isNaN(Number(value))) {
            callback(new Error('未税金额必须为数字'))
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'taxRate',
    label: '税率%',
    required: true,
    type: 'input',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            callback()
            return
          }

          if (!value) {
            callback(new Error('请输入税率'))
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'taxAmount',
    label: '税额(元)',
    required: true,
    type: 'input',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            callback()
          } else if (!value) {
            callback(new Error('税额必填'))
          } else if (isNaN(Number(value))) {
            callback(new Error('税额必须为数字'))
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'amount',
    label: '价税合计(元)',
    type: 'input',
    width: 140,
    required: true,
    rules: [
      {
        validator: (rule, value, callback) => {
          if (rule.row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE) {
            if (!value) {
              callback(new Error('价税合计必填'))
            } else if (isNaN(Number(value))) {
              callback(new Error('价税合计必须为数字'))
            }
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'fileName',
    label: '附件',
    width: 170,
    type: 'a',
    linkProp: 'fileUrl',
    rules: [
      {
        validator: (rule, value, callback) => {
          if (fileRequiredTypes.includes(rule.row.invoiceType) && !value) {
            callback(new Error('电子发票必须上传附件，附件可通过上传发票按钮操作'))
          } else if (customFileRequiredTypes.includes(rule.row.invoiceType) && !value) {
            callback(new Error('区块链电子发票/机打发票/可报销其他发票必须上传附件'))
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
  },
  {
    prop: 'operation',
    label: '操作',
    type: 'operation',
  },
]

/**
 * 根据行和prop判断是否显示disable样式
 */
export const shouldInputDisabled = (row, prop) => {
  if (prop === 'amount' && !amountEditabledTypes.includes(row.invoiceType)) return true
  if (!row.invoiceType) return false

  // 43-可报销发票：不可录入发票号码、发票代码、校验码后6位，未税金额、税额、税率
  if (
    row.invoiceType === INVOICE_TYPE.OTHER_REIMBURSABLE &&
    ['invoiceNo', 'invoiceCode', 'verifyCode', 'unTaxAmount', 'taxAmount', 'taxRate'].includes(prop)
  ) {
    return true
  }

  return (
    (prop === 'verifyCode' && !verifyCodeRequiredTypes.includes(row.invoiceType)) ||
    (prop === 'invoiceCode' && !invoiceCodeRequiredTypes.includes(row.invoiceType)) ||
    (prop === 'amount' && !amountEditabledTypes.includes(row.invoiceType))
  )
}

/**
 * 根据行和prop判断是否需要重置属性值（切换发票类型时）
 */
export const shouldResetProp = (row, prop) => {
  if (!row.invoiceType) return false
  return (
    (prop === 'verifyCode' && !verifyCodeRequiredTypes.includes(row.invoiceType)) ||
    (prop === 'invoiceCode' && !invoiceCodeRequiredTypes.includes(row.invoiceType)) ||
    (prop === 'fileName' && !fileRequiredTypes.includes(row.invoiceType))
  )
}
